<template>
  <div>
    <section class="box-detail form-detail" v-if="customerInfo">
      <h1>Thông tin người đại diện</h1>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Họ và tên <span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.customerName : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Số điện thoại<span class="float-right">:</span></label
        >
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.authoriserContactNumber : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Email<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.authoriserEmail : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Số CMND/CCCD/HC<span class="float-right">:</span></label
        >
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.passport : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Nơi cấp<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.placeOfIssue : '' }}
          </p>
        </div>
      </div>
    </section>

    <section
      v-if="dataContract.groupService !== 'SELL' && customerInfo"
      class="box-detail form-detail"
    >
      <h1>Tài khoản ngân hàng nhận tiền</h1>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Chủ tài khoản <span class="float-right">:</span></label
        >
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.holderName : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label"
          >Số tài khoản<span class="float-right">:</span></label
        >
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.accountNo : '' }}
          </p>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-3 col-form-label">Ngân hàng<span class="float-right">:</span></label>
        <div class="col-sm-8">
          <p class="form-control-plaintext f12">
            {{ customerInfo ? customerInfo.bankName : '' }}
          </p>
        </div>
      </div>
    </section>
    <thongtinnhanhoadon
      :dataContract="dataContract"
      :dataAppendix="dataAppendix"
      :isView="isView"
    ></thongtinnhanhoadon>
    <section
      v-if="
        dataContract.groupService !== 'SELL' &&
        dataContract.merchantBusinessAreas &&
        dataContract.merchantBusinessAreas.length > 0
      "
      class="box-detail form-detail"
    >
      <h1>Điểm chấp nhận thanh toán</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered" id="tableScroll">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Tên điểm</th>
              <th scope="col" class="text-left">Địa chỉ</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.merchantBusinessAreas" :key="index">
            <tr class="table-row">
              <td class="text-left">{{ item.areaName }}</td>
              <td align="left">
                {{ item.areaAddress }}
                <!-- <span v-show="item?.areaWard"> - {{ item?.areaWard }}</span> -->
                <!-- <span v-show="item.areaDistrict">
                  - {{ item.areaDistrict }}</span
                > -->
                <!-- <span v-show="item.areaCity"> - {{ item.areaCity }}</span> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
  import thongtinnhanhoadon from '@/components/contracts/others-component/thongtinnhanhoadon.vue'
  import Config from '@/thirdParty/config'
  export default {
    props: ['dataContract', 'dataAppendix', 'isView'],
    components: { thongtinnhanhoadon },
    data() {
      return {
        listStatusContract: Config.listStatusContract,
      }
    },
    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
